import { DrawCircleCmd } from "../display/cmd/DrawCircleCmd";
import { DrawEllipseCmd } from "../display/cmd/DrawEllipseCmd";
import { DrawPolyCmd } from "../display/cmd/DrawPolyCmd";
import { DrawRectCmd } from "../display/cmd/DrawRectCmd";
import { Graphics } from "../display/Graphics";
import { Rectangle } from "../maths/Rectangle";
import { ClassUtils } from "./ClassUtils";
import { Utils } from "./Utils";
const _rect = new Rectangle();
export class HitArea {
    contains(x, y, sp) {
        if (HitArea._isHitGraphic(x, y, sp, this._unHit))
            return false;
        return HitArea._isHitGraphic(x, y, sp, this._hit);
    }
    moveTo(x, y, hit, unhit) {
        if (hit && this._hit) {
            for (let cmd of this._hit.cmds) {
                cmd.x = x;
                cmd.y = y;
            }
        }
        if (unhit && this._unHit) {
            for (let cmd of this._unHit.cmds) {
                cmd.x = x;
                cmd.y = y;
            }
        }
    }
    static _isHitGraphic(x, y, sp, g) {
        if (!g)
            return false;
        return g.cmds.findIndex(cmd => cmd && HitArea._isHitCmd(x, y, sp, cmd)) !== -1;
    }
    static _isHitCmd(x, y, sp, cmd) {
        if (!cmd)
            return false;
        var rst = false;
        switch (cmd.cmdID) {
            case DrawRectCmd.ID: {
                let tcmd = cmd;
                if (tcmd.percent)
                    _rect.setTo(tcmd.x * sp.width, tcmd.y * sp.height, tcmd.width * sp.width, tcmd.height * sp.height);
                else
                    _rect.setTo(tcmd.x, tcmd.y, tcmd.width, tcmd.height);
                rst = _rect.contains(x, y);
                break;
            }
            case DrawCircleCmd.ID: {
                let tcmd = cmd;
                let r = tcmd.radius;
                let d;
                if (tcmd.percent) {
                    x -= tcmd.x * sp.width;
                    y -= tcmd.y * sp.height;
                    r *= sp.width;
                }
                else {
                    x -= tcmd.x;
                    y -= tcmd.y;
                }
                d = x * x + y * y;
                rst = d < r * r;
                break;
            }
            case DrawEllipseCmd.ID: {
                let tcmd = cmd;
                let d;
                let rx = tcmd.width / 2;
                let ry = tcmd.height / 2;
                if (tcmd.percent) {
                    x -= tcmd.x * sp.width;
                    y -= tcmd.y * sp.height;
                    rx *= sp.width;
                    ry *= sp.height;
                }
                else {
                    x -= tcmd.x;
                    y -= tcmd.y;
                }
                d = Math.pow(x / rx, 2) + Math.pow(x / ry, 2);
                rst = d < 1;
                break;
            }
            case DrawPolyCmd.ID: {
                let tcmd = cmd;
                x -= tcmd.x;
                y -= tcmd.y;
                rst = Utils.testPointInPolygon(x, y, tcmd.points);
                break;
            }
        }
        return rst;
    }
    get hit() {
        if (!this._hit)
            this._hit = new Graphics();
        return this._hit;
    }
    set hit(value) {
        this._hit = value;
    }
    get unHit() {
        if (!this._unHit)
            this._unHit = new Graphics();
        return this._unHit;
    }
    set unHit(value) {
        this._unHit = value;
    }
    onAfterDeserialize() {
        if (this._hitCmds) {
            this.hit.cmds = this._hitCmds;
            delete this._hitCmds;
        }
        if (this._unHitCmds) {
            this.unHit.cmds = this._unHitCmds;
            delete this._unHitCmds;
        }
    }
}
ClassUtils.regClass("HitArea", HitArea);
